import { datadogRum } from '@datadog/browser-rum';

import { getDataDogConfig } from './config';
import { RumEventContext } from './types';

export function sendDataDogEvent(name: string, ctx: RumEventContext | undefined) {
  if (!getDataDogConfig()) return;
  datadogRum.addAction(name, ctx);
}
